export default __webpack_public_path__ + "static/media/hamburger_menu.11e79764.svg";